export enum HelpType {
    ReportAnIssue,
    TrustedMap,
    MyTasks,
    TaskManagement,
    Submissions,
    Legal,
    Consultations,
    Annotations,
    TRO,
    Public
}

